// The ONE confirmation every aircraft tab's Add to W/O shows (Shelley SOP S3/S4,
// 2026-10-14), shared here because the tabs live in different modules (src/aircraft,
// src/inspections-tr via its host, src/ads-and-sbs) and a module must not import another's.
import type { Term } from "../hooks/useTerm";

/**
 * "No demand for -MGB Inspections (no part)." -- the ticked Demands the server could not raise
 * because the component has no part (an AMS group row; Mustang W/O 343, 2026-10-13). Empty when none.
 */
export function demandsSkippedNote(skipped: { label: string }[] | undefined): string {
  const labels = (skipped ?? []).map((s) => (s.label || "").trim() || "a component");
  return labels.length ? `No demand for ${labels.join(", ")} (no part).` : "";
}

/** What an add-to-job route returns: the Components route's counts, the others' `created`. */
export interface AddedToJob {
  job_id: number;
  /** true when the route opened the W/O ("Create new W/O"). */
  created?: boolean;
  tasks?: unknown[];
  demands?: unknown[];
  outworks?: unknown[];
  demands_skipped?: { label: string }[];
}

const counted = (n: number, word: string) => `${n} ${word}${n === 1 ? "" : "s"}`;

/**
 * "Added to W/O #338: 1 task" / "Added to new W/O #404: 2 tasks, 1 demand" -- the ONE
 * confirmation every aircraft tab's Add to W/O shows, in the Components tab's form
 * (Shelley SOP S3/S4, 2026-10-14: Inspections said "2 limitations added to W/O #338",
 * ADs "1 AD added to new W/O #404"). Components, Inspections, Notes, ADs / SBs and
 * Modifications. Counts what the server made, not what was ticked.
 */
export function addedToJobMessage(term: Term, d: AddedToJob): string {
  const parts = [
    d.tasks?.length ? counted(d.tasks.length, "task") : "",
    d.demands?.length ? counted(d.demands.length, "demand") : "",
    d.outworks?.length ? counted(d.outworks.length, "outwork") : "",
  ].filter(Boolean);
  const skipped = demandsSkippedNote(d.demands_skipped);
  return (
    `Added to ${d.created ? "new " : ""}${term.shortSingular} #${d.job_id}` +
    (parts.length ? `: ${parts.join(", ")}` : "") +
    (skipped ? `. ${skipped}` : "")
  );
}
